export const environment = {
  production: true,
  baseUrl: 'https://api.bureau401.fr'
};
